import React from "react";
import {
    Box,
    Grid,
    Button,
    Checkbox,
    Tooltip,
    Skeleton
} from "@mui/material";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import EllipsisWithTooltip from "../PricingModal1/EllipsisWithTooltip";

const PortfolioHomePage = ({
    portfolios,
    isLoading,
    handleCardClick,
    handleDeletePortfolio,
    handleAddNewPortfolio,
    setDefaultCheckedIcon,
    setDefaultUncheckedIcon,
    handleDefaultPortfolio,
    maxPortfolioLimit
}) => {
    return (
        <Box className="portfolio-home-page">

            <div className='portfolio-heading'>
                <div>Portfolios ({portfolios?.length})</div>
                <div className='default-legend'>
                    {setDefaultCheckedIcon}
                    <div>Default Portfolio</div>
                </div>
            </div>

            <Box className='portfolio-body'>

                <OverlayScrollbarsComponent
                    className="custom-overlay-scrollbar scrollable-tab-container"
                    element="div"
                    options={{
                        scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                        overflow: { x: 'hidden', y: 'scroll', }
                    }}
                    defer
                >

                    {/* Skeleton Loader */}
                    {isLoading &&
                        <Grid container spacing={1} className='portfolio-cards-grid'>
                            {[1,2,3,4,5].map((portfolio) => (
                                // <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Grid
                                    item
                                    xs={12}   // 1 card
                                    sm={6}    // 2 cards
                                    md={4}    // 3 cards
                                    lg={3}    // 4 cards
                                    xl={2}    // 6 cards on big screens
                                    key={Math.random()}
                                >
                                    <Box className="portfolio-card skeleton-loader">
                                        <Box className="left-section">
                                            <Skeleton sx={{ width: "220px", height: "20px" }} variant="rounded"></Skeleton>
                                            <Skeleton sx={{ width: "150px", height: "12px" }} variant="rounded"></Skeleton>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    }

                    {/* Portfolio Cards Grid */}
                    {!isLoading &&
                        <Grid container spacing={1} className='portfolio-cards-grid'>
                            {portfolios.map((portfolio) => (
                                // <Grid item xs={12} sm={6} md={4} lg={3} key={portfolio.id}>
                                <Grid
                                    item
                                    xs={12}   // 1 card
                                    sm={6}    // 2 cards
                                    md={4}    // 3 cards
                                    lg={3}    // 4 cards
                                    xl={2}    // 6 cards on big screens
                                    key={portfolio.id}
                                >
                                    <Box className="portfolio-card" tabIndex={0} onClick={()=>handleCardClick(portfolio.id)}>
                                        {/* Left content */}
                                        <Box className="left-section-wrap">
                                            <Box className="default-checkbox">
                                                <Tooltip followCursor title= {(portfolio.name !== "All Hotels") ? "Mark / Unmark as default" :""}>
                                                    <Checkbox
                                                        checked={portfolio.is_default}
                                                        icon={setDefaultUncheckedIcon}
                                                        checkedIcon={setDefaultCheckedIcon}
                                                        onClick={(e) => handleDefaultPortfolio(e, portfolio.id)}
                                                    />
                                                </Tooltip>
                                            </Box>

                                            <Box className="left-section">
                                                <Box className='portfolio-name'><EllipsisWithTooltip width={220} text={portfolio.name} /></Box>
                                                <Box className="hotel-count">Hotels: {portfolio.properties.length}</Box>
                                            </Box>
                                        </Box>

                                        {/* Right action */}
                                        <Box className="right-section">
                                            {portfolio.is_default || portfolio.name === 'All Hotels'?
                                                // <Box className='default-chip'>Default</Box>
                                                <Box></Box>
                                                :
                                                <Tooltip arrow title="Delete">
                                                    <Box className='icon-btn' onClick={(e) => handleDeletePortfolio(e, portfolio.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#606060" viewBox="0 0 256 256"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path></svg>
                                                    </Box>
                                                </Tooltip>
                                            }
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    }
                </OverlayScrollbarsComponent>

            </Box>

            <Button
                variant="outlined"
                className="add-button"
                size="small"
                onClick={handleAddNewPortfolio}
            >
                <span className="add-btn-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#333333" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                </span>
                <span className="add-btn-txt">
                    <div className='primary-text'>Add New Portfolio</div>
                    <div className='secondary-text'>{maxPortfolioLimit - portfolios?.length}/{maxPortfolioLimit} Remaining</div>
                </span>
            </Button>

        </Box>
    );
};

export default PortfolioHomePage;